<template>
    <select :value="modelValue" class="form-select border border-gray-500 rounded-full w-96 focus:border-selected" @change="$emit('update:modelValue', $event.target.value)" ref="input">
        <option value="" selected="0" disabled>{{ placeholder }}</option>
        <option v-for="(text, key) in options" :key="key" :value="text">{{ text }}</option>
    </select>
</template>

<script>
export default {
    props: {
        modelValue: String,
        placeholder: String,
        options: {
            type: Object,
            default:[]
        }
    },

    emits: ['update:modelValue'],

    methods: {
        focus() {
            this.$refs.input.focus()
        }
    }
}
</script>
